import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { getSaledDetails } from "../../redux/actions/api/apiAction";
import { BalanceReportDetails } from "../../views/pages/gymPortion/reports/balanceAccoutDetailsTable";
export const PaymentDueDetails = ({ showModal, toggle, payload }) => {
    const dispatch = useDispatch();
    const { detailsPage, detailsLimit } = useSelector((state) => state.report);
    React.useEffect(() => {
        if (payload.id) {
            dispatch(getSaledDetails({member:payload.id,limit:detailsLimit,page:detailsPage}));
        }
    }, [detailsPage,detailsLimit]);
    return (
        <>
            <Modal isOpen={showModal} toggle={toggle} centered={true}
                size="lg"
                className="large-pop adding-popup ">
                <ModalHeader toggle={toggle}>Account Balance Details</ModalHeader>
                <ModalBody>
                 <BalanceReportDetails/>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
